"use client";

import { backendClient } from "@/lib/backend-api";
import { useQuery } from "@tanstack/react-query";

export function useShopifyConnectionStatus(
  shopId: number,
  enabled: boolean,
  initialRequired?: boolean,
) {
  return useQuery({
    queryKey: ["shopify-connection", shopId],
    queryFn: async () => {
      const shop = await backendClient.shop.getSummary();
      if (shop.id !== shopId) throw new Error("The active shop changed");
      // return shop.shopifyReconnectRequired;
      return false;
    },
    enabled,
    initialData: false, //initialRequired,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
